(() => {
  const STORAGE_KEY = 'vapekorea:wishlist';
  const ADDED_LABEL = '保存済み';
  const ADD_LABEL = 'お気に入り';
  const ADDED_ARIA_LABEL = 'お気に入りから削除';
  const ADD_ARIA_LABEL = 'お気に入りに追加';

  const readWishlist = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('vapekorea:wishlist:update', { detail: { items } }));
    } catch (_error) {
      // localStorage can be unavailable in strict/private browser contexts.
    }
  };

  const getVariantInput = (button) => button.closest('form')?.querySelector('input[name="id"]');

  const getCurrentVariantId = (button) => {
    const variantInput = getVariantInput(button);
    return variantInput?.value || variantInput?.dataset.defaultVariantId || '';
  };

  const getWishlistKey = (button) => {
    const productId = button.dataset.productId || '';
    const variantId = getCurrentVariantId(button);
    return variantId ? `${productId}:${variantId}` : `${productId}:product`;
  };

  const buildWishlistUrl = (button) => {
    const url = button.dataset.productUrl || window.location.pathname;
    const variantId = getCurrentVariantId(button);
    return variantId ? `${url}${url.includes('?') ? '&' : '?'}variant=${encodeURIComponent(variantId)}` : url;
  };

  const buildWishlistItem = (button) => ({
    key: getWishlistKey(button),
    productId: button.dataset.productId || '',
    productHandle: button.dataset.productHandle || '',
    productTitle: button.dataset.productTitle || '',
    productUrl: buildWishlistUrl(button),
    productImage: button.dataset.productImage || '',
    variantId: getCurrentVariantId(button),
    savedAt: new Date().toISOString(),
  });

  const updateButtonState = (button) => {
    const key = getWishlistKey(button);
    const isSaved = readWishlist().some((item) => item.key === key);
    const label = button.querySelector('[data-wishlist-label]');

    button.classList.toggle('is-active', isSaved);
    button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    button.setAttribute('aria-label', isSaved ? ADDED_ARIA_LABEL : ADD_ARIA_LABEL);
    if (label) label.textContent = isSaved ? ADDED_LABEL : ADD_LABEL;
  };

  const syncWishlistButtons = (root = document) => {
    root.querySelectorAll?.('[data-wishlist-button]').forEach(updateButtonState);
  };

  const toggleWishlist = (button) => {
    const key = getWishlistKey(button);
    if (!key || key.startsWith(':')) return;

    const items = readWishlist();
    const nextItems = items.some((item) => item.key === key)
      ? items.filter((item) => item.key !== key)
      : [buildWishlistItem(button), ...items.filter((item) => item.key !== key)];

    writeWishlist(nextItems);
    syncWishlistButtons(document);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-wishlist-button]');
    if (!button) return;

    event.preventDefault();
    toggleWishlist(button);
  });

  document.addEventListener('change', (event) => {
    if (event.target?.matches?.('form[action*="/cart/add"] input[name="id"]')) {
      syncWishlistButtons(document);
    }
  });

  window.addEventListener('vapekorea:wishlist:update', () => syncWishlistButtons(document));
  window.addEventListener('shopify:section:load', (event) => syncWishlistButtons(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncWishlistButtons(document), { once: true });
  } else {
    syncWishlistButtons(document);
  }
})();
